/**
 * @file PasswordAuthentication.jsx
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since May 28, 2023 08:58
 */
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const PasswordAuthentication = (props) => {
    const { children } = props;
    const location = useLocation();

    const [requestedLocation, setRequestedLocation] = useState(null);

    if (requestedLocation && location.pathname !== requestedLocation) {
        setRequestedLocation(null);
        return <navigate to={requestedLocation} />;
    }

    return <>{children}</>;
};

PasswordAuthentication.propTypes = {
    children: PropTypes.node
};

export default PasswordAuthentication;